<template>
    <div class="pt5">
        <div class="container">
            <div class="mb4 mb5-m col-xs-12">
                <h2 :class="{'tc' : xs}">People are loving Tooliaba!</h2>
            </div>
            <div class="row">
                <div v-for="(testimonial, index) in testimonials" :key="index" class="col-xs-12 col-sm-4">
                    <Testimonial :class="{'tc' : xs}" :data="testimonial"/>
                </div>
            </div>
            <TooliabaButton :class="{ 'col-xs-4 col-xs-offset-8' : !xs, 'mb6' : screenSize === 'xs' || screenSize === 'sm' }" class="col-xs-12 center ">Read More Reviews</TooliabaButton>
        </div>
        <img class="pt6 w-100 db" src="@/assets/img/landing/divider_rough_edge_top.svg">
    </div>
</template>

<script>
import Testimonial from '@/components/landing/Testimonial.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    data() {
        return {
            testimonials: [
                {
                    image: require(`@/assets/img/avatars/avatar_1.svg`),
                    name: 'Jill Andrews',
                    date: 'Dec 16, 2018',
                    rating: 5,
                    title: 'We saved a bunch of money on our renos!',
                    description:
                        "My boyfriend and I were able to finish our kitchen renovations without having to spend a lot of money on a bunch of tools we probably won't ever use again"
                },
                {
                    image: require(`@/assets/img/avatars/avatar_15.svg`),
                    name: 'Tyler Mills',
                    date: 'Nov 12, 2018',
                    rating: 5,
                    title: 'The delivery service is actually pretty good!',
                    description:
                        "No matter where I'm working, I can always count on Tooliaba to quickly get me the odd tools I need to get the job done. It's great!"
                },
                {
                    image: require(`@/assets/img/avatars/avatar_3.svg`),
                    name: 'Josh Sanders',
                    date: 'Sep 4, 2018',
                    rating: 5,
                    title: "It's a care-free way to get heavy equipment.",
                    description:
                        "Tooliaba delivers on time so my projects never get delayed. Plus, I don't need to worry about storing equipment when they aren't in use."
                }
            ]
        };
    },
    components: {
        Testimonial,
        TooliabaButton
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        },
        screenSize() {
            return this.$mq;
        }
    }
};
</script>
